import React from "react";
import {
  Button,
  Chip,
  Divider,
  FormFieldSet,
  InfoTimeCardAdv,
  MailRecipient,
  PageTitle,
} from "../../../../../../components";

const ExitEmployeeSendMail = () => {
  return (
    <div>
      <div className="flex gap-8 mb-6">
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Offboarding ID"
            value="EX2022-20"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Date of Release"
            value="11/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Notice Due"
            value="10/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Exit Type"
            value="Resignation"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Status"
            value="Released"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
      </div>
      <div>
        <MailRecipient />
      </div>
      <div>
        <div className="flex items-center mt-6 gap-3 max-w-5xl">
          <div>Feilds:</div>

          <div className="flex-1">
            <FormFieldSet noTitle placeholder="Select " type="select" />
          </div>
          <div className="flex-1">
            <FormFieldSet noTitle placeholder="Select " type="select" />
          </div>
          <div>
            <Button title={"Add"} />
          </div>
        </div>
      </div>
      <div className="my-6">
        <div>Subject</div>
      </div>
      <div className="min-h-60 border-[1px] border-neutrals-100 p-4 rounded-sm">
        Text Editor
      </div>
      <div className="flex mt-6">
        <PageTitle
          title={"Pending Actions"}
          // icon={"detection_and_zone"}
          tag="p"
        />
      </div>
      <Divider className="my-2" />
      <div className="flex gap-4">
        <Chip
          label={"Pending Timesheets"}
          icon={"close"}
          iconPosition="after"
          size="md"
        />
        <Chip label={"H1B Details List"} icon={"close"} iconPosition="after" />
        <Chip
          label={"Greencard Details List"}
          icon={"close"}
          iconPosition="after"
        />
      </div>
      <div className="flex gap-3 justify-end mt-24">
        <Button title="Cancel" variant="outlined" />
        <Button title="Send" />
      </div>
    </div>
  );
};

export default ExitEmployeeSendMail;
